import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleParagraph1, Button, Label } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';

import * as styles from './BlackFridayBanner.css';
import { IBlackFridayBanner } from '../../types/blackFriday';
import { Section } from '../Section';

interface IBlackFridayBannerProps extends IBlackFridayBanner {
  onClick: () => void;
  onShow: () => void;
}

export const BlackFridayBanner: React.FC<IBlackFridayBannerProps> = ({
  background,
  buttonText,
  buttonTheme,
  labels,
  subtitle,
  textColor,
  title,
  url,
  onClick,
  onShow,
}) => {
  return (
    <Section data-testid="BlackFridayBannerSection">
      <ActionAfterViewObserver callback={onShow} wrapper={false}>
        <a
          className={styles['container']}
          style={{ background }}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClick}
        >
          <div className={styles['content']} style={{ color: textColor }}>
            <div className={styles['labels']} data-testid="BlackFridayBannerLabels">
              {labels.map((label, index) => (
                <Label key={index} background={label.background} color={label.color}>
                  {label.text}
                </Label>
              ))}
            </div>
            <h2 className={styles['heading']}>{title}</h2>
            <ArticleParagraph1 color="current_color" whiteSpace="pre-line">
              {subtitle}
            </ArticleParagraph1>
            <div className={styles['button-wrapper']}>
              <Button theme={buttonTheme as TButtonTheme}>{buttonText}</Button>
            </div>
          </div>
        </a>
      </ActionAfterViewObserver>
    </Section>
  );
};
